import { render } from "./AddEditRegistration.vue?vue&type=template&id=0ee7b801&scoped=true"
import script from "./AddEditRegistration.vue?vue&type=script&lang=js"
export * from "./AddEditRegistration.vue?vue&type=script&lang=js"

import "./AddEditRegistration.vue?vue&type=style&index=0&id=0ee7b801&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee7b801"]])

export default __exports__